export default "__VITE_ASSET__9M_RZHyP__"